import { IApplicationState } from '../../types/redux';
import { getFromDevelopersPropsCount } from './getFromDevelopersPropsCount';

export const getHasOffersFromDeveloper = (state: IApplicationState): boolean => {
  const fromDeveloperPropsCount = getFromDevelopersPropsCount(state);

  return Boolean(fromDeveloperPropsCount);
};
